import { Component } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { connect } from "react-redux";
import * as dashboardSearchActions from "member/redux/modules/dashboardSearch";
import { components } from "react-select";
import ListGroup from "react-bootstrap/ListGroup";
import { Image } from "react-bootstrap";
import DebounceAsync from "../DebounceAsync";
import environmentVariables from "shared/enviromentVariables/index.js.erb";
import { isOpenRemunerationPlan } from "shared/plans";
import { mixpanelTrack } from "../../../shared/trackEvents/mixpanelTracking";
import {
  GLOBAL_SEARCH_EVENT_NAMES,
  MIXPANEL_PROPS,
} from "shared/trackEvents/constants";

const search = (props, searchFor, searchText, callback) => {
  if (searchText.length <= 2) {
    return callback(false);
  }
  const { loading, searchData } = props;

  if (!loading) {
    searchData({ type: searchFor, query: searchText }, callback);
  }
};

const Control = ({ children, ...props }) => {
  return <components.Control {...props}>{children}</components.Control>;
};

const MenuList = (props) => {
  const children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return (
    <ListGroup
      variant="flush"
      ref={innerRef}
      {...innerProps}
      className={cx(
        {
          "menu-list": true,
          "menu-list--is-multi": isMulti,
        },
        className
      )}
      style={getStyles("menuList", props)}
    >
      {children}
    </ListGroup>
  );
};

const Option = (props) => {
  const children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    image = props.data.image,
    subTitle = props.data.subTitle;
  return (
    <ListGroup.Item
      ref={innerRef}
      {...innerProps}
      className={cx(
        {
          option: true,
          "option--is-disabled": isDisabled,
          "option--is-focused": isFocused,
          "option--is-selected": isSelected,
        },
        className
      )}
      style={getStyles("option", props)}
    >
      <div className="d-flex flex-row">
        <div>
          <Image
            src={image}
            style={{
              maxHeight: "50px",
              maxWidth: "50px",
              height: "auto",
              width: "auto",
            }}
          />
        </div>
        <div className="d-flex flex-column justify-content-start ml-2">
          <div>{children}</div>
          <div style={{ color: "green" }}>({subTitle})</div>
        </div>
      </div>
    </ListGroup.Item>
  );
};

class DashboardSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchFor: "all",
      user: props.user,
      isOpenRemunerationUser: isOpenRemunerationPlan(props.user),
    };
  }

  _filterValues = () => {
    return this.props.result.map((result, index) => {
      const { id, name, sub_title, image, path } = result;
      return {
        id: id,
        value: `${index}-${id}`,
        label: name,
        subTitle: sub_title,
        image: image,
        path: `#/${path}/${id}`,
      };
    });
  };

  _handleChange = (inputValue, resolve, reject) => {
    const { searchFor } = this.state;

    search(this.props, searchFor, inputValue, (success) => {
      if (success) resolve(this._filterValues());
      else reject("Something went wrong. Please try again later.");
    });
  };

  _handleResultClick = (object) => {
    if (this.props.forProfile == true) {
      this.props.setDirector(object);
    } else {
      if (this.state.isOpenRemunerationUser) {
        mixpanelTrack(GLOBAL_SEARCH_EVENT_NAMES.OR_SEARCH_RESULT_CLICKED, {
          [MIXPANEL_PROPS.RESULT_SELECTED]: object.label || "unknown",
          userEmail: this.props.user?.email,
        });
      } else {
        mixpanelTrack(GLOBAL_SEARCH_EVENT_NAMES.OD_SEARCH_RESULT_CLICKED, {
          [MIXPANEL_PROPS.RESULT_SELECTED]: object.label || "unknown",
          userEmail: this.props.user?.email,
        });
      }
      if (object) window.location = object.path;
    }
  };

  _formSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.target;

    if (form.checkValidity() === false) {
      form.classList.add("was-validated");
    } else {
      const { searchFor } = this.state;
      search(this.props, searchFor, "");
    }
  };

  render() {
    const { searchFor } = this.state;

    const customStyles = {
      container: (provided, state) => ({
        ...provided,
        width: "280px",
      }),
      option: (provided, state) => ({
        ...provided,
        cursor: "pointer",
      }),
      menu: (provided, state) => ({
        ...provided,
        width: "250px",
      }),
      control: (provided, state) => ({
        ...provided,
        borderRadius: 0,
      }),
    };

    return (
      <Form
        inline
        style={{ width: "100%" }}
        onSubmit={this._formSubmit}
        noValidate="novalidate"
        autoComplete="off"
      >
        <div className="autocomplete" style={{ width: "100%" }}>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text
                style={{
                  borderRadius: 0,
                  backgroundColor: "#1E6685",
                  color: "white",
                  border: "none",
                }}
              >
                <i className="fas fa-search" style={{ fontSize: "14px" }}></i>
              </InputGroup.Text>
            </InputGroup.Prepend>
            <DebounceAsync
              placeholder={"Search all people and companies"}
              loadOptions={this._handleChange}
              onChange={(value) => this._handleResultClick(value)}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
                Option,
                MenuList,
                Control,
              }}
              results={this.props.result}
              styles={customStyles}
            />
          </InputGroup>
        </div>
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const { dashboardSearch, users } = state;

  const { loading, loaded, result } = dashboardSearch;

  return {
    loading,
    loaded,
    result,
    user: users.user,
  };
}

const mapDispatchToProps = {
  searchData: dashboardSearchActions.search,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSearch);
